module.exports = __webpack_public_path__ + "img/ContactUsicon.86f8f20.png";